import { DatePicker } from 'antd'
import type { DatePickerProps } from 'antd'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

/** 统一日期选择（中文 locale 在 main.tsx 已配置） */
export function AppDatePicker(props: DatePickerProps) {
  return <DatePicker format={DATE_FORMAT} style={{ width: '100%', ...props.style }} {...props} />
}

/** 后端 datetime.utcnow() 为 UTC 无时区后缀；带 Z/偏移量则按原样解析。 */
function parseApiDate(value: string | dayjs.Dayjs) {
  if (dayjs.isDayjs(value)) return value
  const s = String(value).trim()
  if (!s) return dayjs(Number.NaN)
  if (/Z$|[+-]\d{2}:\d{2}$/.test(s)) return dayjs(s)
  return dayjs.utc(s).local()
}

export function formatDate(value: string | dayjs.Dayjs | null | undefined) {
  if (value == null || value === '') return ''
  const d = parseApiDate(value)
  return d.isValid() ? d.format(DATETIME_FORMAT) : ''
}

/** 表格等场景：空值显示 — */
export function formatDateOrDash(value: string | dayjs.Dayjs | null | undefined) {
  return formatDate(value) || '—'
}

export function formatDateOnly(value: string | dayjs.Dayjs | null | undefined) {
  if (value == null || value === '') return ''
  const d = parseApiDate(value)
  return d.isValid() ? d.format(DATE_FORMAT) : ''
}
